import { styled } from 'styled-components'
import Box from '@mui/material/Box'

export const StyledLayoutWrapper = styled(Box)`
height: calc(100% - 64px);
`
